import { Role } from "@models/role";

export function getClassroomsStats({
  classroomService,
  userId,
  role,
  orgCode,
}) {
  return role === Role.INSTRUCTOR.id
    ? classroomService.getClassroomsStatsForInstructor(userId)
    : classroomService.getClassroomsStatsForOrg(orgCode);
}

export function getClassrooms({
  classroomService,
  userId,
  role,
  orgCode,
  status,
  isOrgSelected,
}) {
  const getClassroomRequest = () => {
    if (role === Role.INSTRUCTOR.id) {
      return classroomService.getClassroomsStatsForInstructor(userId, status);
    } else if (role === Role.ORG_ADMIN.id || isOrgSelected) {
      return classroomService.getClassroomsStatsForOrg(orgCode, status);
    } else {
      return classroomService.getMultiOrgClassroomsStats(orgCode, status);
    }
  };

  return getClassroomRequest();
}
